let authToken = ''

export const setAuthToken = (s) => {
  authToken = s
}

export const getAuthToken = () => {
  return authToken
}
